export class Compass {
	width: number;
	height: number;
	rotation: number;
	compass_group: any;
	
	create(container: any) {
		var radius = this.width / 4;
		var interact = radius * 0.7;
		var pad = 20;

		this.compass_group = container.append("g");
		this.compass_group.attr("transform", "translate(50, 50) ");

		this.compass_group.append("circle").attr("class", "arc-minor").attr("cx", this.width/2 - interact).attr("cy", this.height/2).attr("r", interact);
		this.compass_group.append("circle").attr("class", "arc-minor").attr("cx", this.width/2).attr("cy", this.height/2 + interact).attr("r", interact);
		this.compass_group.append("circle").attr("class", "arc-minor").attr("cx", this.width/2 ).attr("cy", this.height/2 - interact).attr("r", interact);    
		this.compass_group.append("circle").attr("class", "arc-minor").attr("cx", this.width/2 + interact).attr("cy", this.height/2).attr("r", interact);

		// build the cardinal winds
		this.compass_group.append("circle").attr("class", "arc").attr("cx", this.width/2 - interact).attr("cy", this.height/2 - interact).attr("r", radius);
    
		this.compass_group.append("circle").attr("class", "arc").attr("cx", this.width/2 + interact).attr("cy", this.height/2 - interact).attr("r", radius);
    
		this.compass_group.append("circle").attr("class", "arc").attr("cx", this.width/2 - interact).attr("cy", this.height/2 + interact).attr("r", radius);
    
		this.compass_group.append("circle").attr("class", "arc").attr("cx", this.width/2 + interact).attr("cy", this.height/2 + interact).attr("r", radius);

		// build the outer circle
		this.compass_group.append("circle").attr("class", "arc-heavy").attr("cx", this.width/2).attr("cy", this.height/2).attr("r", this.width / 2);
    
		// labels
		this.compass_group.append("text").attr("class","direction").attr("y", pad).attr("x", this.width/2).text("N");
		
		return this.compass_group;
	}

	rotate(degrees) {
		this.rotation = degrees;
		this.compass_group.attr('transform', 'translate(50, 50) rotate(' + this.rotation + ', ' + (this.width / 2) + ', ' + (this.height / 2) + ')');
	} 

    constructor(nWidth: number, nHeight: number, nRotation: number) {
    	this.width = nWidth;
    	this.height = nHeight;
    	this.rotation = nRotation;
    }

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/compass.ts